module.exports = __webpack_public_path__ + "static/media/portfolio6.181fc8b0.png";